import { render, staticRenderFns } from "./icon-check.vue?vue&type=template&id=f5c31dd8&scoped=true&"
import script from "./icon-check.vue?vue&type=script&lang=js&"
export * from "./icon-check.vue?vue&type=script&lang=js&"
import style0 from "./icon-check.vue?vue&type=style&index=0&id=f5c31dd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c31dd8",
  null
  
)

export default component.exports